'use strict';

angular.module('theme').component('eventSignup', {
	templateUrl: 'component/event-signup.html',
	controller: function ($rootScope, CustomerService, Toast, $cookies, $location) {
		var self = this;
		self.gdprAccepted = false;

		var paramString = window.location.search;
		var urlParams = new URLSearchParams(paramString);

		if ($cookies.get('campaign-code-discount')) {
			var discount = JSON.parse($cookies.get('campaign-code-discount'));

			self.discountCode = discount.code;

			if (!discount || discount.code === '') return;

			if (discount.type === 'Percent') {
				self.percentDiscount = Math.abs(discount.value) / 100;
			} else if(discount.amount) {
				var value = Math.abs(discount.amount);

				if (value == 0) return;

				self.discount = value;
			}
		}

		this.eventRegister = function (email, name, telnr) {
			self.errorMsg = '';
			self.saving = true;
			var campaignCode = urlParams.get('dc') || '';
			var howDidYouFindUs = urlParams.get('event') || '';

			CustomerService.eventRegister(email, name, telnr, campaignCode, howDidYouFindUs).then(function () {
				self.saving = false;

				Toast.successContent('<i class="mk-icon mk-icon-share mk-icon-x5"></i><h2 class="mt-md">Kampanjkod skickad!</h2>');
			}, function (errorResponse) {
				self.errorMsg = errorResponse.data.message;
			});
		};
	}
});
